import { ReactNode } from 'react';

import styles from '@components/typography/Typography.module.css';

type Props = {
  bold?: boolean;
  children: ReactNode;
  color?: 'primary700' | 'primary500' | 'neutral200' | 'shadesWhite' | 'neutral500' | 'neutral300';
};

const Heading2 = ({ bold = true, children, color = 'primary700' }: Props) => (
  <h2 className={`${styles.heading2} ${styles[color]} ${bold ? '' : styles.normalWeight}`}>{children}</h2>
);

export default Heading2;
